import { Table } from "react-bootstrap";
import SpinnerBlock from "components/others/SpinnerBlock";
import { useObject } from "../context/ObjectProvider";
import TableHeadTdOrder from "components/others/TableHeadTdOrder";
import { useTranslation } from "react-i18next";
import ObjectsTableBody from "./ObjectsTableBody";

const ObjectsTable = ({objectsList, fetchObjects, setClientInfoId, setTasksObjectId}) => {

    const { t } = useTranslation(['Objects']);
    const { showSpinner, setShowSpinner,
            objectsOrder, setObjectsOrder,
            objectsDesc, setObjectsDesc,
            showDebtor, showClient, showTeam, showCreated, showAccess, showInWork, isSaleLike } = useObject();

    const handleOrderClick = (value, desc) => {
        setObjectsOrder(value); 
        setObjectsDesc(desc);
    }

    const tableMods = [
        isSaleLike ? 'ObjectTable--sales' : '',
        showDebtor ? 'ObjectTable--payments' : '',
        showClient ? 'ObjectTable--client' : '',
        showTeam ? 'ObjectTable--team' : '',
    ].filter(Boolean).join(' ');
    const tableMinWidth = (isSaleLike ? 760 : 780)
        + (showCreated ? 160 : 0)
        + (showAccess ? 160 : 0)
        + (showInWork ? 160 : 0)
        + (showClient ? 180 : 0)
        + (showTeam ? 150 : 0)
        + (showDebtor ? 230 : 0);

    return (<>
        <SpinnerBlock 
            onlyBlur={true}
            show={showSpinner}/> 

        <div className="crm-table-wrap objects-table-wrap">
            <Table
                className={`ObjectTable table-hover${tableMods ? ` ${tableMods}` : ''}`}
                style={{ minWidth: tableMinWidth }}
            >
                <thead>
                    <tr className="bg-light">
                        <td className="head-name">
                            <TableHeadTdOrder
                                title={t('fields.name')}
                                onClick={handleOrderClick}
                                value={objectsOrder}
                                desc={objectsDesc}
                                fieldName={isSaleLike ? 'object_name' : 'client_name'}/>
                        </td>

                        <td className="head-status">{t('fields.status')}</td>

                        {showClient ? (
                            <td className="head-client">
                                <TableHeadTdOrder
                                    title={t('fields.client')}
                                    onClick={handleOrderClick}
                                    value={objectsOrder}
                                    desc={objectsDesc}
                                    fieldName='client_name'/>
                            </td>
                        ) : null}

                        {!isSaleLike ? (
                            <td className="head-created">
                                <TableHeadTdOrder
                                    className="cursor-pointer d-flex align-items-center"
                                    title={t('fields.date')}
                                    onClick={handleOrderClick}
                                    value={objectsOrder}
                                    desc={objectsDesc}
                                    fieldName='client_created'/>    
                            </td>
                        ) : null}

                        {showTeam ? (
                            <td className="head-team">
                                <TableHeadTdOrder
                                    title={t('fields.team')}
                                    onClick={handleOrderClick}
                                    value={objectsOrder}
                                    desc={objectsDesc}
                                    fieldName='team_name'/>     
                            </td>
                        ) : null}

                        {isSaleLike ? (
                            <td className="head-created">
                                <TableHeadTdOrder
                                    className="cursor-pointer d-flex align-items-center"
                                    title={t('fields.saleDate')}
                                    onClick={handleOrderClick}
                                    value={objectsOrder}
                                    desc={objectsDesc}
                                    fieldName='object_created'/>    
                            </td>
                        ) : null}

                        {showCreated ? (
                            <td className="head-author">
                                <TableHeadTdOrder
                                    title={t('fields.created')}
                                    onClick={handleOrderClick}
                                    value={objectsOrder}
                                    desc={objectsDesc}
                                    fieldName='user_name'/>    
                            </td>
                        ) : null}

                        {showAccess ? (
                            <td className="head-access">{t('listColumns.access')}</td>
                        ) : null}

                        {showInWork ? (
                            <td className="head-in-work">
                                <TableHeadTdOrder
                                    title={t('listColumns.inWork')}
                                    onClick={handleOrderClick}
                                    value={objectsOrder}
                                    desc={objectsDesc}
                                    fieldName='in_work_user_name'/>
                            </td>
                        ) : null}

                        {showDebtor ? (
                            <td className="head-payments text-end">{t('fields.payments')}</td>
                        ) : null}
                        <td className="head-price text-end">
                            <TableHeadTdOrder
                                className="cursor-pointer d-flex align-items-center justify-content-end"
                                title={t('fields.price')}
                                onClick={handleOrderClick} 
                                value={objectsOrder}
                                desc={objectsDesc}
                                fieldName='object_price'/>    
                        </td>
                        <td className="head-action">{t('fields.action')}</td>
                    </tr>
                </thead> 
                
                <ObjectsTableBody
                    setClientInfoId={setClientInfoId}
                    setTasksObjectId={setTasksObjectId}
                    objectsList={objectsList}
                    fetchObjects={fetchObjects}/>
            </Table>
        </div>
    </>)
}

export default ObjectsTable; 
